import { render, staticRenderFns } from "./RcSummary.vue?vue&type=template&id=5b98e0b6&"
import script from "./RcSummary.vue?vue&type=script&lang=js&"
export * from "./RcSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports